












import { Component, Vue } from 'vue-property-decorator';
import { search } from '@/utils/http';
import { store } from '@/utils/store';

@Component
export default class SearchBox extends Vue {
  searchText = ''

  get selfUserName() {
    return store.githubId ?? '';
  }

  search() {
    store.loading = true;
    // search('tetsushi', 's').then((searchResults) => { // ←テストnp用
    search(this.selfUserName, this.searchText)
      .then((searchResults) => { // ←本番用
        store.searchResults = searchResults;
        if (this.$route.name !== 'Search') {
          this.$router.push({ name: 'Search' });
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        store.loading = false;
      });
  }
}
